import Axios, { AxiosRequestConfig } from 'axios';
import {
  CLIENT_TYPE_HEADER,
  CLIENT_TYPE,
} from '@upstart/harmony/lib/constants';
// eslint-disable-next-line import/no-cycle
import AuthService from './AuthService';
import { broadcastNewSessionTimeout } from '../utils/session-timeout';
import { getSystemStatus } from '../utils/systemMaintenanceUtils';
import {
  CLIENT_CODENAMES,
  X_UAR_HTTP_HEADERS,
} from '@upstart/harmony/lib/legos/constants/system';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const SYSTEM_STATUS_URL = process.env.REACT_APP_SYSTEM_STATUS_URL;
const DEFAULT_HEADERS = {
  [CLIENT_TYPE_HEADER]: CLIENT_TYPE.IN_STORE,
  [X_UAR_HTTP_HEADERS['X-UAR-Client-Codename']]: CLIENT_CODENAMES.LAUNCHPAD,
};
const SESSION_DURATION_HEADER = X_UAR_HTTP_HEADERS['X-UAR-Session-Duration'];

Axios.interceptors.response.use(
  (response) => {
    const sessionTimeout =
      parseInt(response.headers?.[SESSION_DURATION_HEADER], 10) || 0;
    if (sessionTimeout) {
      broadcastNewSessionTimeout(sessionTimeout);
    }
    return response;
  },
  async function (error) {
    if (
      error.code === 'ERR_NETWORK' ||
      (error.response?.status >= 500 && error.response?.status < 600)
    ) {
      if (error.config.url === SYSTEM_STATUS_URL) {
        return Promise.reject(error);
      }

      await getSystemStatus();
    }

    return Promise.reject(error);
  },
);
export class BackendService {
  public static async get<T>(url: string, options?: AxiosRequestConfig) {
    return Axios.get<T>(
      BACKEND_URL + url,
      BackendService.addAuthHeader(options),
    );
  }
  public static post<T>(
    url: string,
    data?: unknown,
    options?: AxiosRequestConfig,
  ) {
    return Axios.post<T>(
      BACKEND_URL + url,
      data,
      BackendService.addAuthHeader(options),
    );
  }
  public static put<T>(
    url: string,
    data?: unknown,
    options?: AxiosRequestConfig,
  ) {
    return Axios.put<T>(
      BACKEND_URL + url,
      data,
      BackendService.addAuthHeader(options),
    );
  }
  public static delete<T>(url: string, options?: AxiosRequestConfig) {
    return Axios.delete<T>(
      BACKEND_URL + url,
      BackendService.addAuthHeader(options),
    );
  }

  private static addAuthHeader(
    options?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const headers = {
      ...DEFAULT_HEADERS,
      ...(options?.headers || {}),
      ...(AuthService.isLoggedIn() && {
        'x-uar-access-token': `Bearer ${AuthService.getToken()}`,
      }),
    };
    const params = {
      ...(options?.params || {}),
    };

    return {
      ...(options || {}),
      headers,
      params,
    };
  }
}
